<div [id]="ariaId" class="SuggestionsListElement" [ngClass]="isSelected ? 'SuggestionsListElement--focused' : ''" (mousedown)="itemClicked()" [attr.aria-selected]="isSelected"
role="option" aria-selected="isSelected">
	<div class="SuggestionsListElement__icon" [ngClass]="locationEnabled ? 'LocationIcon' : 'LocationDisabledIcon'"></div>
	<div class="SuggestionsListElement__text"> {{ text }} </div>
</div>
